// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__1R6Vh","select":"Header_select__3DeQa","clinic":"Header_clinic__2Rhqv"};